import { color, OnyxGray } from 'canoe';
import styled from 'styled-components';

export const Separator = styled.div`
  height: 2px;
  width: 100%;
  background-color: ${color(OnyxGray)};
`;
